RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    graph.GroupedBar = graph.Block.mixin({
        className: 'grouped-bar',
        columns: 4,
        height: 125,
        rowMargin: 25,
        groupMargin: 10,
        groupBorderExtension: 10,
        ticks: 5,

        mixins: {
            CalculatedMargin: graph.mixins.CalculatedMargin
        },

        margin: {
            top: 26,
            right: 10,
            bottom: 0
        },

        getHeight: function () {
            const me = this;
            const margin = me.getMargin();
            const rows = me.data.length;
            const rowMargin = (rows - 1) * me.getOption('rowMargin') + rows * (margin.top + margin.bottom);
            return rows * me.getOption('height') + rowMargin;
        },

        processData: function (data) {
            const me = this;
            const columns = me.getOption('columns');
            const groupByType = _.values(_.groupBy(data, _.property('1')));
            return _.chunk(groupByType, columns);
        },

        getDimensions: function () {
            const me = this;

            const width = $(document).width();

            me.options.columns = 4;
            if (width <= 768) {
                me.options.columns = 2;
            }

            if (width <= 480) {
                me.options.columns = 1;
            }

            return graph.Block.prototype.getDimensions.call(me);
        },

        getYMax: function () {
            const me = this;

            // Get it from the flat representation
            return d3.max(me.getOption('data'), _.last);
        },

        renderData: function (svg, data) {
            const me = this;
            const margin = me.getMargin();

            const yMax = me.getYMax();
            const y = d3.scale.linear()
                .range([me.getOption('height'), 0])
                .domain([0, yMax])
                .nice();

            const rows = svg.selectAll('.chart-row')
                .data(data);

            const newRows = rows.enter().append('g')
                .attr('class', 'chart-row')
                .attr('transform', function (d, i) {
                    let offset = me.getOption('height') * i;
                    offset = offset + i * (me.getOption('rowMargin') + margin.top + margin.bottom);
                    return `translate(0,${offset})`;
                });

            newRows.append('g')
                .attr('class', 'y grid');

            newRows.append('g')
                .attr('class', 'x grid');

            newRows.append('g')
                .attr('class', 'x axis');

            newRows.append('g')
                .attr('class', 'y axis');

            rows.exit().remove();

            // TODO I think this would be better as a single render w/o
            // grouping the data before, using ordinal scales to pick the location of
            // the group
            rows
                .each(_.partial(me.renderRow, me, y));
        },

        renderRow: function (me, y, d, rowIndex) {
            const node = d3.select(this);

            const concept = me.getOption('concept');
            const metrics = me.getOption('metrics');
            const colors = metrics.invoke('getColor');
            const classNames = metrics.invoke('getClassName');
            const customClassNames = me.getOption('classNames');

            const dimensions = me.dimensions;
            const groupCount = me.getOption('columns');
            const barCount = d[0].length;
            const groupMargin = me.getOption('groupMargin');
            const startIndex = rowIndex * groupCount;
            const groupNames = _.chunk(me.getOption('groupNames'), groupCount);

            const width = (dimensions.width - (2 * groupMargin * groupCount)) / groupCount;

            const paddedScale = function (x) {
                const margins = 2 * x;
                return width * x + margins * groupMargin;
            };

            const groupX = d3.scale.linear()
                .domain(d3.range(groupCount + 1))
                .range(_.map(d3.range(groupCount + 1), paddedScale));

            const x = d3.scale.ordinal()
                .domain(d3.range(0, barCount))
                .rangeBands([0, width], 0.1, 0);

            const createYAxis = function (scale) {

                return d3.svg.axis()
                    .scale(scale)
                    .orient('left')
                    .ticks(me.getOption('ticks'));
            };

            const metric = (metrics.first() || concept);
            const yAxisFormatter = metric.getFormat({
                abbreviate: true
            }) || RivalIQ.formatter.formats.abbreviated;
            const yAxis = createYAxis(y).tickFormat(function (d) {
                return yAxisFormatter(d);
            });

            const shouldAnimate = (!me.isResizing && !RivalIQ.isHeadless);

            node.select('.y.grid').each(function (groups) {
                d3.select(this).call(me.animate, createYAxis(y).tickSize(-1 * paddedScale(groups.length), 0, 0).tickFormat(''), shouldAnimate);
            });

            // A scale function that puts ticks at the edges of graphs
            // and in the middle of bars not at the edges
            const labelScaleFn = function (i) {
                if (i === 0) {
                    return 0;
                }
                if (i === barCount - 1) {
                    return width;
                }
                return x(i) + x.rangeBand() / 2;
            };

            const xLabelScale = d3.scale.ordinal()
                .range(_.map(d3.range(0, barCount), labelScaleFn))
                .domain(d3.range(0, barCount));

            const domain = me.getDomain(metric);
            const continuous = metric.hasContinuousDomain();
            const xAxis = d3.svg.axis()
                .scale(xLabelScale)
                .orient('bottom')
                .tickValues(concept.getTicks(2))
                .tickFormat(function (d) {

                    if (continuous && d === _.last(domain)) {
                        const tick = concept.getTick(d, {
                            format: false
                        })[1];
                        return concept.domainFormat(tick);
                    }

                    return concept.getTick(d);
                });

            node.select('.x.grid').each(function (groups) {
                const groupAxis = d3.svg.axis()
                    .scale(groupX)
                    .orient('bottom')
                    .tickValues(d3.range(groups.length + 1))
                    .tickSize(me.getOption('height') + 2 * me.getOption('groupBorderExtension'), 0)
                    .tickFormat('');

                d3.select(this).call(groupAxis);
            });

            node.select('g.y.axis')
                .call(me.animate, yAxis, shouldAnimate);

            const group = node.selectAll('.grouping')
                .data(_.identity);

            const newGroups = group.enter()
                .append('g')
                .attr('class', 'grouping');

            newGroups
                .append('g')
                .attr('class', 'x axis');

            newGroups
                .append('text')
                .attr('class', 'group-label')
                .style('text-anchor', 'middle');

            group
                .attr('transform', function (d, i) {
                    return `translate(${groupX(i) + groupMargin}, 0)`;
                });

            group.exit()
                .remove();

            group.selectAll('.group-label')
                .attr('transform', 'translate(0, -6)')
                .attr('x', function (d, i) {
                    return (paddedScale(i + 1) - paddedScale(i)) / 2;
                })
                .attr('title', function (d, i, j) {
                    return groupNames[rowIndex][j];
                })
                .attr('data-toggle', 'tooltip')
                .text(function (d, i, j) {
                    return RivalIQ.formatter.urlShort(groupNames[rowIndex][j]);
                });

            group.selectAll('.x.axis')
                .attr('transform', `translate(0,${me.getOption('height')})`)
                .call(xAxis);

            group.selectAll('.x.axis').each(function () {
                const ticks = d3.select(this).selectAll('.tick');
                d3.select(ticks[0][0]).select('text')
                    .style('text-anchor', 'start');

                d3.select(ticks[0][ticks[0].length - 1]).select('text')
                    .style('text-anchor', 'end');
            });

            const rect = group.selectAll('rect')
                .data(_.identity);

            rect
                .enter()
                .append('rect')
                .attr('x', function (d, i) { return x(i); })
                .attr('y', function (d) { return y(_.last(d)); });

            rect
                .attr('class', function (d, i, j) { return [customClassNames.apply(me, arguments), classNames[startIndex + j]].join(' '); })
                .attr('fill', function (d, i, j) { return colors[startIndex + j]; })
                .call(me.animate, function (nodes) {
                    nodes
                        .attr('width', x.rangeBand())
                        .attr('x', function (d, i) { return x(i); })
                        .attr('y', function (d) { return y(_.last(d)); })
                        .attr('height', function (d) { return me.getOption('height') - y(_.last(d)); });
                }, shouldAnimate);

            rect
                .exit()
                .remove();

            rect.call(graph.utils.createTooltip, me.getOption('tooltip'), startIndex, {
                classNames: classNames
            });
        },

        onBeforeDestroy: function () {
            const me = this;

            me.$('rect').popover('destroy');
        }
    });

    graph.GroupedBar.reloadable = true;

}, window.d3);
